import { ChangeDetectorRef, Directive, ElementRef, HostListener, inject, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[upperCaseInput]',
    standalone: true,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: UpperCaseInputDirective,
            multi: true,
        },
    ],
})
export class UpperCaseInputDirective implements ControlValueAccessor {
    private el = inject(ElementRef);
    private changeDetectorRef = inject(ChangeDetectorRef);

    @Input() upperCaseInput = true;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private onChange = ({}) => {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private onTouched = () => {};

    @HostListener('input', ['$event']) onInput(): void {
        if (this.upperCaseInput) {
            this.el.nativeElement.value = this.el.nativeElement.value.toUpperCase();
            this.onChange(this.el.nativeElement.value);
            this.onTouched();
        } else {
            this.onChange(this.el.nativeElement.value);
            this.onTouched();
        }
    }

    writeValue(value: any): void {
        if (this.upperCaseInput) {
            this.el.nativeElement.value = value?.toUpperCase();
        } else {
            this.el.nativeElement.value = value;
        }
        this.changeDetectorRef.detectChanges();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
